import { RegistrationPath } from 'pages/Registration/hooks/useRegistration'
import { useState } from 'react'
import RegistrationForm from './components/RegistrationForm'
import ValidationForm from './components/ValidationForm'
import * as Styles from './styles'

interface FormsProps {
  onGoBack: () => void
  path: RegistrationPath
}
type FormsStep = 'validation' | 'registration'

export default function Forms({ onGoBack, path }: FormsProps) {
  const [step, setStep] = useState<FormsStep>('validation')

  const onRegistrationFormsGoBack = () => {
    if (path === 'professional') {
      setStep('validation')
      return
    }
    onGoBack()
  }

  return (
    <Styles.FormsContainer>
      <Styles.Title>{path === 'professional' ? 'Cadastro Profissional da Saúde' : 'Associe-se'}</Styles.Title>

      {path === 'professional' && step === 'validation' && (
        <ValidationForm onGoBack={onGoBack} onValidationSuccess={() => setStep('registration')} />
      )}
      {(path === 'patient' || step === 'registration') && (
        <RegistrationForm onGoBack={onRegistrationFormsGoBack} path={path} />
      )}
    </Styles.FormsContainer>
  )
}
